export default "__VITE_ASSET__ea4bb390__"